import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import { GET_UF_STAGE_ONE, GET_UF_STAGE_TWO,ADD_UF_STAGE_ONE_DATA, GET_UF_STAGE_ONE_DATA,GET_UF_STAGE_TWO_DATA,ADD_UF_STAGE_TWO_DATA,UPDATE_UF_FLOW_STATUS, GET_VIEW_UF_STAGE_ONE_DATA,GET_VIEW_UF_STAGE_TWO_DATA, UPDATE_UF_FLOW, GET_UF_FLOW_HISTORY , GET_UF_FRAME_NOS, FETCH_MASTER_UF_NUMBERS, DELETE_UNDER_FRAME_DATA, CHECK_DUP_UNDER_FRAME } from '../../../api/apiConstant';


export const fetchUfStageOneForm = createAsyncThunk(
  'underFrame/fetchUfStageOneForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_UF_STAGE_ONE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchUfStageTwoForm = createAsyncThunk(
  'underFrame/fetchUfStageTwoForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_UF_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const addUfStageOneData = createAsyncThunk(
  'underFrame/addUfStageOneData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_UF_STAGE_ONE_DATA, data);
      console.log(35,response)
      return response.data;
    } catch (error) {
      console.log(37,error)
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add under frame stage one data',
      );
    }
  },
);
export const fetchUfStageOneData = createAsyncThunk(
  'underFrame/fetchUfStageOneData',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_UF_STAGE_ONE_DATA, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchUfStageTwoData = createAsyncThunk(
  'underFrame/fetchUfStageTwoData',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_UF_STAGE_TWO_DATA, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const addUfStageTwoData = createAsyncThunk(
  'underFrame/addUfStageTwoData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_UF_STAGE_TWO_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add under frame stage one data',
      );
    }
  },
);

export const UpdateFlowStatus = createAsyncThunk(
  'underFrame/UpdateFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_UF_FLOW_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add under frame stage one data',
      );
    }
  },
);

export const fetchViewUfStageOneData = createAsyncThunk(
  'underFrame/fetchViewUfStageOneData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_UF_STAGE_ONE_DATA, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);   


export const fetchViewUfStageTwoData = createAsyncThunk(
  'underFrame/fetchViewUfStageTwoData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_UF_STAGE_TWO_DATA, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
); 

export const UpdateUfFlowStatus = createAsyncThunk(
  'underFrame/UpdateUfFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_UF_FLOW, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update status',
      );
    }
  }
);

export const fetchUfFlowHistory = createAsyncThunk(
  'underFrame/fetchUfFlowHistory',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_UF_FLOW_HISTORY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch history'
      );
    }
  }
);

export const fetchUfFrameNo = createAsyncThunk(
  'underFrame/fetchUfFrameNo',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_UF_FRAME_NOS, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch history'
      );
    }
  }
);
export const fetchUfMasterNumbers = createAsyncThunk(
  'underFrame/fetchUfMasterNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_UF_NUMBERS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Under frame numbers',
      );
    }
  },
);

export const deleteUnderFrame = createAsyncThunk(
  'furnishing/deleteUnderFrame',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_UNDER_FRAME_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);


export const checkDuplicateFrametype = createAsyncThunk(
  'underFrame/checkDuplicateFrametype',
  async(data,{ rejectWithValue })=>{
    try {
      const response = await api.post(CHECK_DUP_UNDER_FRAME, data);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
)